import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {IDistribution} from "../models/distributions.interface";
import {IPackage} from "../models/packages.interface";

@Injectable({
  providedIn: 'root',
})
export class DistributionsRepository {
  constructor(private http: HttpClient) {}

  getDistributionsData(): Observable<IDistribution[]> {
    const url = `${environment.apiUrl}/api/v1/Distribution/GetDistributionsWithPackages`;
    return this.http.get<IDistribution[]>(url);
  }

  getAllPackages(): Observable<IPackage[]> {
    const url = `${environment.apiUrl}/api/v1/Package/GetAllPackages`;
    return this.http.get<IPackage[]>(url);
  }

  createEditDistribution(data) {
    const url = `${environment.apiUrl}/api/v1/Distribution`;
    return this.http.post(url, data);
  }
}
